import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=777abd3a&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=777abd3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777abd3a",
  null
  
)

export default component.exports